<template>
    <div id="wrapper">
        <Header/>
        <main>
            <section class="list-group-content">
                <Navbar/>
                <div id="page-content-wrapper" :class="{removePadding: this.$store.state.loading}" @click="closeMenuOutside">
                    <Loading/>
                    <router-view/>
                </div>
            </section>
        </main>
    </div>
</template>

<script>

import Navbar from './partials/Navbar'
import Header from './partials/Header'
import Loading from '../components/Loading'

export default {
  name: 'Template',
  components: {
    Navbar,
    Header,
    Loading
  },
  updated () {
    this.closeMenuOutside()
  },
  mounted () {
    this.closeMenuOutside()
  },
  methods: {
    closeMenuOutside () {
      let mainWrapper = document.getElementById('wrapper')
      let burger = document.querySelector('.burger')
      if (!mainWrapper.classList.contains('toggled')) {
        mainWrapper.classList.add('toggled')
        burger.classList.toggle('open_burger')
      }
    }
  }
}
</script>
